"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSection = FilterSection;
const react_1 = __importStar(require("react"));
const i18n_1 = require("@tcc/i18n");
const fds_1 = require("@tcc/fds");
const crate_1 = require("@tcc/crate");
const TableFilters_css_1 = require("./TableFilters.css");
function FilterSection({ columnId, columnLabel, options, selectedValues, prefixTestId, onToggleOption, onSelectAll, }) {
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const toggleSection = (0, react_1.useCallback)(() => {
        setIsExpanded((prev) => !prev);
    }, []);
    const getFilteredOptions = (0, react_1.useCallback)((opts) => {
        if (!searchValue)
            return opts;
        return opts.filter((opt) => opt.label.toLowerCase().includes(searchValue.toLowerCase()));
    }, [searchValue]);
    const filteredOptions = getFilteredOptions(options);
    const allValues = filteredOptions.map((o) => o.value);
    const allSelected = allValues.length > 0 && allValues.every((v) => selectedValues.includes(v));
    const selectedCount = selectedValues.length;
    return (react_1.default.createElement("div", { key: columnId, className: TableFilters_css_1.filterSection },
        react_1.default.createElement("div", { className: TableFilters_css_1.filterSectionHeader, onClick: toggleSection, "data-test-id": `${prefixTestId}-section-${columnId}` },
            react_1.default.createElement("span", null,
                columnLabel,
                selectedCount > 0 && ` (${selectedCount})`),
            react_1.default.createElement(fds_1.Icon, { icon: isExpanded ? fds_1.FdsIcon.KeyBoardArrowUp : fds_1.FdsIcon.KeyBoardArrowDown, variation: fds_1.IconVariation.Filled })),
        isExpanded && (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: TableFilters_css_1.filterSearchBox },
                react_1.default.createElement(crate_1.TextInput, { testId: `${prefixTestId}-search-${columnId}`, placeholder: (0, i18n_1.getMessage)('table.filters.search.placeholder', { column: columnLabel }), value: searchValue, onChange: (e) => {
                        setSearchValue(e.target.value);
                    } })),
            react_1.default.createElement("div", { className: TableFilters_css_1.filterOptionsList },
                filteredOptions.length > 1 && (react_1.default.createElement("div", { className: TableFilters_css_1.filterOption },
                    react_1.default.createElement(crate_1.Checkbox, { "data-test-id": `${prefixTestId}-select-all-${columnId}`, checked: allSelected, onChange: () => onSelectAll(columnId, allValues) }),
                    react_1.default.createElement("span", null, (0, i18n_1.getMessage)('table.filters.selectAll')))),
                filteredOptions.map((option) => (react_1.default.createElement("div", { key: option.value, className: TableFilters_css_1.filterOption },
                    react_1.default.createElement(crate_1.Checkbox, { "data-test-id": `${prefixTestId}-option-${columnId}-${option.value}`, checked: selectedValues.includes(option.value), onChange: () => onToggleOption(columnId, option.value) }),
                    react_1.default.createElement("span", null, option.label)))),
                filteredOptions.length === 0 && (react_1.default.createElement("div", { className: TableFilters_css_1.filterOption },
                    react_1.default.createElement("span", null, (0, i18n_1.getMessage)('table.filters.noResults')))))))));
}
